export * from "./static-calendar"